<script setup lang="ts">
  const props = defineProps({
    percent: { type: Number as PropType<number | null>, required: false },
    indeterminate: { type: Boolean, required: false },
    message: { type: String, required: false }
  })
</script>

<template>
  <div>
    <GeneralText v-if="props.message" class="d-block text-caption">
      {{ props.message }}
      <template v-if="props.percent !== null"> ({{ props.percent }}%) </template>
    </GeneralText>
    <v-progress-linear
      :model-value="props.percent ?? undefined"
      :indeterminate="props.indeterminate"
      color="primary"
      height="6"
      rounded
    ></v-progress-linear>
  </div>
</template>

<style lang="css" scoped></style>
